import { get } from '@vueuse/core'

export const getProjectIdFromRoute = routeRequest => {
  const routeParams = get(routeRequest)?.params || {}
  const projectId = routeParams?.projectId
  return projectId
}
